import axios from 'axios';
import 'bulma/css/bulma.min.css';
import React, { useState } from 'react';
import liff from '@line/liff';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as actions from './actions'
import AppConfig from './AppConfig.json'
import RichMenuDesigner from './RichMenuDesigner';
import { MD5 } from 'crypto-js';
import App from './App';

class LogViewer extends React.Component {

    state = {
        line_access_token: null,
        logs: [],
        selectedType: 'info',
        passwordAccepted: false
    }

    constructor() {
        super()
        this.getLogs = this.getLogs.bind(this)
    }

    componentDidMount() {
        if (MD5(window.prompt("????")).toString() === AppConfig.backend_passhash) {
            this.setState({ passwordAccepted: true })
        }
        else return

        this.initializeLiff(AppConfig.liff_id)
        this.clearInterval = setInterval(() => {
            this.getLogs()
        }, 5000)
    }

    componentWillUnmount() {
        this.clearInterval && this.clearInterval()
    }

    async initializeLiff(myLiffId) {
        try {
            await liff.init({
                liffId: myLiffId
            })

            if (!liff.isLoggedIn()) {
                // console.log("Login")
                liff.login()
            }
            else {
                // let profile = await liff.getProfile()
                this.state.line_access_token = liff.getAccessToken()
                // console.log("Logined", this.state.line_access_token)
                this.getLogs()
            }
        }
        catch (err) {
            console.log(err)
        }
    }

    async getLogs() {
        let { selectedType, line_access_token } = this.state

        if (selectedType && line_access_token) {
            let result = await axios.get(this.props.name === 'worker' ? `${AppConfig.endpoint}/member/backend/logs_worker/${selectedType}.json` : `${AppConfig.endpoint}/member/backend/logs/${selectedType}.json`, {
                headers: {
                    "x-access-token": this.state.line_access_token,
                    "x-api-key": AppConfig.api_key
                }
            })

            this.setState({ logs: result.data })
        }
    }

    render() {
        let { passwordAccepted, logs } = this.state
        if (!passwordAccepted) return ""
        if (!this.state.line_access_token) return ""
        if (!logs) return "Loading"

        return <>
            <div className="container" style={{
                fontSize: "0.9em",
                fontFamily: "monospace",
                padding: "1px 5px"
            }}>
                <button onClick={() => { this.setState({ selectedType: 'info' }); this.getLogs() }}>info</button>
                <button onClick={() => { this.setState({ selectedType: 'error' }); this.getLogs() }}>error</button>
                <table>
                    {logs.map(l => <tr>
                        <td>{l.time}</td>
                        <td style={{ wordBreak: "break-word" }}>{l.content}</td>
                    </tr>)}
                </table>
            </div>
        </>
    }
}

export default withRouter(connect((state) => state, actions)(LogViewer))